import { writable } from 'svelte/store';

// Reflects the most recently loaded active-alarm count from Overview or Alerts; not polled independently.
export const activeAlarmCount = writable<number | null>(null);
